import { atom } from 'jotai';

export const isCreateTemplateModalOpenAtom = atom(false);
